var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B2B2BC",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9.938A6.044 6.044 0 0 1 21.273 13H10.727a6.042 6.042 0 0 1 5.047-3.058L16 9.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0c7.698 0 14.133 5.565 15.717 13h-4.12C26.117 7.784 21.467 4 16 4 10.532 4 5.884 7.784 4.403 13H.283C1.867 5.565 8.302 0 16 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.155 19A6.045 6.045 0 0 1 16 21.863 6.045 6.045 0 0 1 10.845 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.683 30.149-.555.835-.58.85a94.494 94.494 0 0 1-2.951 4.013l-.73.933c-.248.313-.5.63-.757.947l-.784.963c-.266.323-.536.649-.811.977l-.838.992-.43.502-.878 1.015-.906 1.03-.463.52-.463-.52-.906-1.03-.878-1.015-.852-1-.825-.984-.402-.487-.784-.963-.757-.947-.73-.933-.703-.917-.341-.454-.662-.895-.636-.88-.608-.866C2.95 26.78.853 22.502.163 18.999h4.093c.44 1.702 1.299 3.699 2.582 5.972l.404.702.43.719c.223.364.455.734.696 1.11l.497.761c.085.129.17.258.258.387l.536.787c.183.264.37.532.563.802l.589.82c.2.275.406.554.615.835l.642.852.331.432.682.876.708.892.364.452.748.916.775.931.323.384.325-.384.775-.931.377-.46.735-.909.709-.892.344-.44.669-.868.642-.852.615-.836.298-.412.576-.811.55-.795c.268-.393.526-.78.774-1.16l.484-.754c2.01-3.184 3.299-5.905 3.872-8.127h4.092c-.611 3.107-2.329 6.824-5.153 11.15z",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group-2.cd2fadc83d098fcbb083c14263123129.svg";
export { ForwardRef as ReactComponent };